{
  "cartDetails": {
    "id": "ID",
    "proceedToCheckout": "Proceed to Checkout",
    "cartName": "Cart #{{code}}"
  },
  "cartItems": {
    "id": "Art.Nr.",
    "description": "Beschreibung",
    "item": "Item",
    "itemPrice": "Einzelpreis",
    "quantity": "Anzahl",
    "quantityTitle": "Die Anzahl stellt die Gesamtanzahl dieses Artikels in Ihrem Warenkorb.",
    "total": "Gesamtpreis",
    "cartTotal": "Warenkorb Gesamt ({{count}} Artikel)",
    "cartTotal_plural": "Warenkorb Gesamt ({{count}} Artikel)"
  },
  "orderCost": {
    "orderSummary": "Bestellzusammenfassung",
    "subtotal": "Subtotal after discounts:",
    "shipping": "Shipping:",
    "estimatedShipping": "Estimated shipping:",
    "discount": "You saved:",
    "salesTax": "Sales Tax:",
    "grossTax": "The order total does not include tax of",
    "grossIncludeTax": "The order total includes tax of",
    "total": "Warenwert Total:",
    "toBeDetermined": "TBD"
  },
  "voucher": {
    "coupon": "Have a coupon?",
    "coupon_plural": "Coupon codes",
    "apply": "Apply",
    "placeholder": "Promo code",
    "applyVoucherSuccess": "{{voucherCode}} has been applied.",
    "removeVoucherSuccess": "{{voucherCode}} has been removed.",
    "anchorLabel": "Enter or remove your coupon code",
    "vouchersApplied": "Applied coupons",
    "availableCoupons": "Available coupons",
    "availableCouponsLabel": "You can add these coupons to this order."
  },
  "saveForLaterItems": {
    "itemTotal": "Saved for later ({{count}} item)",
    "itemTotal_plural": "Saved for later ({{count}} items)",
    "cartTitle": "Cart",
    "saveForLater": "Save For Later",
    "moveToCart": "Move To Cart",
    "stock": "Stock",
    "forceInStock": "In Stock"
  }
}